import { AxiosInstance } from "axios";
import { Plan } from "../models/plan";

const PLANS_API_PREFIX = "/plans/plans";

export const getPlans = async (http: AxiosInstance): Promise<Plan[]> => {
	const response = await http.get<Plan[]>(PLANS_API_PREFIX + "/active");

	return response.data;
};
